export {
  RadioButton as RadioButtonLegacy,
  RadioButtonProps as RadioButtonPropsLegacy
} from './RadioButtonLegacy';
